import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=72934d2b&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"
import style0 from "./LoginLayout.vue?vue&type=style&index=0&id=72934d2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72934d2b",
  null
  
)

export default component.exports